import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import * as R from 'ramda';

@Injectable({
  providedIn: 'root',
})
export class TitleService {
  constructor(private title: Title, private translateService: TranslateService) {}

  setTitle(title: string) {
    const translationPlaceholders = title.match(/{[\w]+}/g);

    if (translationPlaceholders && translationPlaceholders.length) {
      const translationKeys: string[] = translationPlaceholders.map((placeholder: string): string =>
        placeholder ? placeholder.replace(/[{}]/g, '') : null,
      );

      this.translateService.get(translationKeys).subscribe(translations => {
        let translatedTitle = title;

        R.map(key => {
          const value = translations[key];

          translatedTitle = translatedTitle.replace(`{${key}}`, value);
        }, R.keys(translations));

        this.title.setTitle(`${translatedTitle} - Gelato`);
      });

      return;
    }

    this.title.setTitle(`${this.translateService.instant(title)} - Gelato`);
  }
}
